import type { ToolCatalogEntry } from '@/shared/types/tool-catalog.types';
import type { ToolsGridFilters } from './ToolsGrid.types';

/**
 * The three filters narrow together: a tool has to survive all of them. Search
 * matches the name only, which is what the field promises.
 */
export function filterTools(
  tools: ToolCatalogEntry[],
  { search, category, kind }: ToolsGridFilters,
): ToolCatalogEntry[] {
  const query = search.trim().toLowerCase();

  return tools.filter(
    (tool) =>
      (!category || tool.category === category) &&
      (!kind || tool.kind === kind) &&
      (!query || tool.title.toLowerCase().includes(query)),
  );
}
